import { render, staticRenderFns } from "./passwordSet.vue?vue&type=template&id=054023e4&"
import script from "./passwordSet.vue?vue&type=script&lang=js&"
export * from "./passwordSet.vue?vue&type=script&lang=js&"
import style0 from "./passwordSet.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports